import SubscriptionCancelPage from './SubscriptionCancelPage';

export default SubscriptionCancelPage;
